/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withStorefront } from '@thd-olt-component-middleware/pip';

import { BrowseSearchMetadata }
from '@thd-olt-component-react/metadata';

import { Breadcrumbs }
from '@thd-olt-component-react/breadcrumbs';

import { SponsoredBannerComposable }
from '@thd-olt-component-react/sponsored-content';

import {
  PLPResultsHeader, ResultsAppliedComposable, ResultsFilterAndSortDrawerComposable, ResultsDimensionsComposable, ResultsSortByComposable, ResultsPaginationComposable
}
from '@thd-olt-component-react/product-results';

import { ProductCategoryVisnavComposable }
from '@thd-olt-component-react/product-category-visnav';

import { HybridContentfulWidgetComposable }
from '@thd-olt-component-react/hybrid';

import { DefaultGridComposable }
from '@thd-olt-component-react/plp-grid';

import { SearchFeedback }
from '@thd-olt-component-react/search-feedback';

import { PLPRecsComposable, PlpRvRenderPlaceholder }
from '@thd-olt-component-react/thd-recs-containers';

import { RetailMediaCarouselFusionComposable }
from '@thd-olt-component-react/retail-media-pla-sponsored-placements';

import { RelatedSearch }
from '@thd-olt-component-react/related-search';

import { BrowseSearchRedirector }
from '@thd-nucleus/app-render';

import { CompareTrayComposable }
from '@thd-olt-component-react/compare';

import { TempDatasourcesHackForFusionDataModels }
from '@thd-olt-component-react/temp-datasources-hack-for-fusion-dataModels';

export { BrowseSearchMetadata };

export { Breadcrumbs };

export { SponsoredBannerComposable };

export { PLPResultsHeader };

export { ProductCategoryVisnavComposable };

export { HybridContentfulWidgetComposable };

export { ResultsAppliedComposable };

export { ResultsFilterAndSortDrawerComposable };

export { ResultsDimensionsComposable };

export { ResultsSortByComposable };

export { DefaultGridComposable };

export { ResultsPaginationComposable };

export { SearchFeedback };

export { PLPRecsComposable };

export { RetailMediaCarouselFusionComposable };

export { PlpRvRenderPlaceholder };

export { RelatedSearch };

export { BrowseSearchRedirector };

export { CompareTrayComposable };

export { TempDatasourcesHackForFusionDataModels };

const SlotA1 = withLayout(
  [

    BrowseSearchMetadata,

  ],

);

const SlotA2 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotB1 = withLayout(
  [

    SponsoredBannerComposable,

  ],

);

const SlotB2 = withLayout(
  [

    PLPResultsHeader,

  ],

);

const SlotB3 = withLayout(
  [

    ProductCategoryVisnavComposable,

  ],

);

const SlotB4 = withLayout(
  [

    HybridContentfulWidgetComposable,

  ],

);

const SlotC1 = withLayout(
  [

    ResultsAppliedComposable,

  ],

);

const SlotC2 = withLayout(
  [

    ResultsFilterAndSortDrawerComposable,

  ],

);

const SlotD1 = withLayout(
  [

    ResultsDimensionsComposable,

  ],

);

const SlotE1 = withLayout(
  [

    ResultsSortByComposable,

  ],

);

const SlotF1 = withLayout(
  [

    DefaultGridComposable,

  ],

);

const SlotF2 = withLayout(
  [

    ResultsPaginationComposable,

  ],

);

let RulesMiddleware_MiddlewareSlot_SlotF3 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_SlotF3 = withStorefront(RulesMiddleware_MiddlewareSlot_SlotF3, { render: { name: 'EPROCUREMENT' } });

const SlotF3 = withLayout(
  [

    SearchFeedback,

  ],

  RulesMiddleware_MiddlewareSlot_SlotF3

);

const SlotG1 = withLayout(
  [

    PLPRecsComposable,

  ],

);

let RulesMiddleware_MiddlewareSlot_SlotG2 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_SlotG2 = withStorefront(RulesMiddleware_MiddlewareSlot_SlotG2, { render: { name: 'EXCHANGE' } });

const SlotG2 = withLayout(
  [

    RetailMediaCarouselFusionComposable,

  ],

  RulesMiddleware_MiddlewareSlot_SlotG2

);

const SlotG3 = withLayout(
  [

    PlpRvRenderPlaceholder,

  ],

);

const SlotG4 = withLayout(
  [

    RelatedSearch,

  ],

);

const SlotG5 = withLayout(
  [

    BrowseSearchRedirector,

  ],

);

const SlotG6 = withLayout(
  [

    CompareTrayComposable,

  ],

);

const SlotG7 = withLayout(
  [

    TempDatasourcesHackForFusionDataModels,

  ],

);

const ssr = typeof window === 'undefined';

export {

  SlotA1,

  SlotA2,

  SlotB1,

  SlotB2,

  SlotB3,

  SlotB4,

  SlotC1,

  SlotC2,

  SlotD1,

  SlotE1,

  SlotF1,

  SlotF2,

  SlotF3,

  SlotG1,

  SlotG2,

  SlotG3,

  SlotG4,

  SlotG5,

  SlotG6,

  SlotG7,

};